/*
function notifyAddCart($i){
  $('.loading').hide();
  $.jGrowl($i,{
    life: 3000
  });
}
*/

function notifyAddCartFail($i){
  $('.loading').hide();
  $.jGrowl($i,{
    life: 3000,
    position:'center'
  });	
}

/* Ajax Add To Cart */

function addToCart(e){
  if (typeof e !== 'undefined') e.preventDefault();

  /* Show loading */
  $('.loading').show();

  var $this = $(this);

  $this.addClass('disabled');

  var form = $this.parents('form');

  // Hide Modal
  $('.modal').modal('hide');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
  
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  $('.add-to-cart').removeClass('disabled');
  $('.addcart-modal-box').css("display", "block");
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  
  $('.loading').hide();
  $('#layer-addcart-modal').show();
  // Bold:POv2 - Update bold cart.
  if(typeof window.BOLD !== 'undefined'
     && typeof window.BOLD.common !== 'undefined'
     && typeof window.BOLD.common.cartDoctor !== 'undefined') {
    // NOTE: "cart" should be the variable containing the cart json data
    jqXHR = window.BOLD.common.cartDoctor.fixItem(jqXHR);
  }
  // Bold:POv2

  //BOLD Dev 10/06/17
  var total_options_price = 0;
  var options = jqXHR != null ? options = jqXHR.properties_all : null; 	
  var pricesArray = options != null && options._boldVariantPrices != null ? options._boldVariantPrices.split(",") : null;
  if(pricesArray != null)
  {
    for(var i = 0; i < pricesArray.length; i++)
    {
      var curr_price = pricesArray[i] != null ? parseInt(pricesArray[i]) : 0 ;
      total_options_price += curr_price;
    }
  }
  //End BOLD Dev 10/06/17
  
  var price = jqXHR['price'];
  var qty = jqXHR['quantity'];
  var total = price * qty;
  var addcart_modal_image = '<img src="'+ Shopify.resizeImage(jqXHR['image'], 'small') +'" alt="'+ jqXHR['title'] +'"/>';
  var addcart_modal_name = '<div>'+jqXHR['product_title']+'<br></div>';
  var addcart_modal_options =  jqXHR.properties_formatted;
  
  //BOLD Dev 10/06/17  
  if (total_options_price > 0)
  {
    addcart_modal_options += "<strong>Total Extras:</strong> <span class='money' style='color:#AD0000'>" + Shopify.formatMoney(total_options_price, _bc_config.money_format) + " </span><br />";
  }
  
  //Original Code var addcart_modal_variant = ""; if(jqXHR['variant_title'] != null) addcart_modal_variant = '{{ "cart.general.variant" | t }}: '+jqXHR['variant_title'];
  var addcart_modal_variant = ""; if(jqXHR['variant_title'] != null) addcart_modal_variant = 'Variant: '+jqXHR['variant_title'];
  //Original Code var addcart_modal_qty = '<strong>{{ "cart.general.quantity" | t }}:</strong>'+jqXHR['quantity'];
  var addcart_modal_qty = '<strong>Quantity: </strong>'+jqXHR['quantity'];
  // Original Code var addcart_modal_price = '<strong>{{ "general.header.cart_info.subtotal" | t }}:</strong>'+Shopify.formatMoney(total, _bc_config.money_format);
  var addcart_modal_price = '<strong>Subtotal: </strong>'+Shopify.formatMoney(total, _bc_config.money_format);
  //var addcart_modal_numpro = ""; if ($(".basket .number .n-item").html() == 1) addcart_modal_numpro = "{{ 'general.cart_modal.cart_modal_number_text_1' | t }} 1 {{ 'general.cart_modal.cart_modal_number_text_3' | t }}."; else addcart_modal_numpro = "{{ 'general.cart_modal.cart_modal_number_text_2' | t }} "+$(".basket .number .n-item").html()+" {{ 'general.cart_modal.cart_modal_number_text_4' | t }}.";
  
  //add data
  
  $('.addcart-modal-image').html(addcart_modal_image);
  $('.addcart-modal-title').html(addcart_modal_name);
  $('.addcart-modal-price').html(addcart_modal_price);
  //BOLD Dev 10/06/17    
  $('.addcart-modal-options').html(addcart_modal_options);
  //End BOLD Dev 10/06/17
  $('.addcart-modal-variant').html(addcart_modal_variant); 
  $('.addcart-modal-qty').html(addcart_modal_qty);
  $('.addcart-modal-number').html(addcart_modal_numpro);
  $('.addcart-modal-box').show();

  // Get the cart show in the cart box.
  Shopify.getCart(function(cart) {
    if(typeof window.BOLD !== 'undefined'
       && typeof window.BOLD.common !== 'undefined'
       && typeof window.BOLD.common.cartDoctor !== 'undefined') {
      // NOTE: "cart" should be the variable containing the cart json data
      cart = window.BOLD.common.cartDoctor.fix(cart);
    }

    Shopify.updateCartInfo(cart, '#cart-info #cart-content');		
  });
  
  	setTimeout(function(){
      // window.location.href = "/checkout";
    }, 1200);
  
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);

  var $i = '<div class="error">'+ response.description +'</div>';
  notifyAddCartFail($i);
}

function addcartModalHide(){
  $("#layer-addcart-modal").addClass("zoomOut animated").fadeOut();
  $("#layer-addcart-modal").removeClass("zoomOut animated");
  // Reload the page
      location.reload();
}

(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var g = {

      common : {
        init: function(){
          $("body").on( 'click','.add-to-cart', addToCart );
        }
      }
  
      ,templateIndex : {
        init: function(){}
      }

      ,templateProduct : {
        init: function(){}
      }

      ,templateCart : {
        init: function(){}
      }
	}  
    ,u = {
        fire: function(t, a, o) {
            var e = g;
            a = void 0 === a ? "init" : a, "" !== t && e[t] && "function" == typeof e[t][a] && e[t][a](o)
        }
        ,loadEvents: function() {
            var t = document.body.id;
            u.fire("common"), $.each(document.body.className.split(/\s+/), function(a, o) {
                u.fire(o), u.fire(o, t)
            })
        }
    };

$(document).ready(u.loadEvents);